<template>
    <div class="nav-sidebar">
        <div class="nav-sidebar__wrapper">
            <ul class="nav-sidebar-tree">
                <li class="nav-sidebar-tree__wrapper">
                    <div class="nav-sidebar-tree__item-wrapper">
                        <router-link
                            :to="routes.allOfferRoute"
                            tag="div"
                            class="nav-sidebar-tree__item"
                        >
                            <i class="icon--md icon-chevron_left  nav-sidebar-tree__icon"></i>
                            <span class="nav-sidebar-tree__title">
                                {{ $t('back to offer') | upperCase }}
                            </span>
                        </router-link>
                    </div>
                </li>
                <li class="nav-sidebar-tree__wrapper">
                    <div class="nav-sidebar-tree__item-wrapper">
                        <router-link
                            :to="routes.verifyTicketRoute"
                            tag="div"
                            class="nav-sidebar-tree__item"
                        >
                            <i class="icon icon-ticket_2 nav-sidebar-tree__icon icon--md"/>
                            <span class="nav-sidebar-tree__title">
                                {{ $t('check ticket') }}
                            </span>
                        </router-link>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import { routeNames } from '@app/router';

    export default {
        created() {
            this.routes = {
                verifyTicketRoute: { name: routeNames.verifyTicket },
                allOfferRoute: { name: routeNames.landing }
            };
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/modules/country/shops/components/ShopsSidebar.vue